<template>
  <v-dialog v-model="show" max-width="700" scrollable>
    <v-form ref="form" @submit.prevent="submit">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.stop="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ WindowLable }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field label="Name" v-model="title" :rules="inputRules" />
          <v-text-field
            v-if="
              selected === 'feeder' ||
              selected === 'substation' ||
              selected === 'dt'
            "
            :rules="inputRules"
            label="Substation Name"
            v-model="substationName"
          />
          <v-text-field
            v-if="selected === 'feeder' || selected === 'substation'"
            label="Feeder Name"
            v-model="feederName"
            :rules="inputRules"
          />

          <v-text-field
            v-if="selected === 'dt'"
            label="DT Name"
            v-model="dtName"
            :rules="inputRules"
          />

          <v-select
            v-model="selected"
            label="Profile Type"
            :items="profileType"
            item-text="title"
            item-value="value"
          >
          </v-select>
          <div v-if="selected !== 'state_level'">
            <Selectcustom
              Lable="Feeder Type"
              DataSource="feederTypes"
              @SelectedItem="setval"
              :selectedValue="feederType"
              itemText="title"
              itemValue="title"
            />
          </div>

          <v-row>
            <v-col>
              <v-text-field
                v-model="pincode"
                type="number"
                label="Pincode"
                @input="onPincodeChange"
                :rules="pincodeRules"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="stateName" label="State" readonly>
              </v-text-field>
            </v-col>
          </v-row>

          <div v-if="selected == 'dt'">
            <v-text-field
              v-model="dtCapacityKVA"
              :rules="numberRules"
              type="number"
              label="Capacity (KVA)"
            >
            </v-text-field>

            <v-text-field
              v-model="feederLengthKm"
              :rules="numberRules"
              type="number"
              label="Feeder Length (Km)"
            >
            </v-text-field>

            <v-text-field
              v-model="dtTapping"
              :rules="numberRules"
              type="number"
              label="Tapping"
            >
            </v-text-field>

            <v-text-field
              v-model="primaryVoltage"
              :rules="numberRules"
              type="number"
              label="Primary Voltage"
            >
            </v-text-field>

            <v-text-field
              v-model="secondaryVoltage"
              :rules="numberRules"
              type="number"
              label="Secondary Voltage"
            >
            </v-text-field>
            <!-- <v-text-field
              v-model="powerFactor"
              :rules="numberRules"
              type="number"
              label="Power Factor"
            >
            </v-text-field> -->

            <v-row v-if="EditMode === true">
              <v-col>
                <v-text-field
                  v-if="EditMode === true"
                  v-model="profileFileName"
                  label="Current File Name"
                  readonly
                />
              </v-col>
              <v-col>
                <v-file-input
                  label="Data File"
                  v-model="fileData"
                  :rules="EditMode !== true ? inputRules : []"
                  @change="onFileChange(fileData, 'fileData')"
                >
                </v-file-input>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="profileYear"
                  label="Year"
                />
              </v-col>
            </v-row>
            <v-row>
             <v-col>
            <v-file-input
              v-if="EditMode === false"
              label="Data File"
              v-model="fileData"
              :rules="inputRules"
              @change="onFileChange(fileData, 'fileData')"
            >
            </v-file-input>
             </v-col>
              <v-col>
                  <v-text-field 
                  v-if="EditMode === false"
                    v-model="profileYear"
                    label="Year"
                  />
              </v-col>
            </v-row>
          </div>
          <v-text-field
            v-model="powerFactor"
            :rules="numberRules"
            type="number"
            label="Power Factor"
          >
          </v-text-field>
          <v-text-field
            v-model="sanctionedLoadMW"
            :rules="numberRules"
            type="number"
            label="Sanctioned Load (MW)"
          />
          <div v-if="selected == 'substation'">
            <v-text-field
              v-model="totalCapacityMVA"
              :rules="numberRules"
              type="number"
              label="Total Capacity (MVA)"
            >
            </v-text-field>
            <v-text-field
              v-model="feederCount"
              :rules="numberRules"
              type="number"
              label="Number of feeders"
            >
            </v-text-field>

            <v-text-field
              v-model="incomingFeederVoltageKV"
              :rules="numberRules"
              type="number"
              label="Incoming Feeder Voltage (KV)"
            >
            </v-text-field>
            <v-text-field
              v-model="outgoingFeederVoltageKV"
              :rules="numberRules"
              type="number"
              label="Outgoing Feeder Voltage (KV)"
            >
            </v-text-field>
            <!-- <v-text-field
              v-model="powerFactor"
              :rules="numberRules"
              type="number"
              label="Power Factor"
            >
            </v-text-field> -->
            <v-text-field
              v-model="feederLengthKm"
              :rules="numberRules"
              type="number"
              label="Feeder Length (Km)"
            />

            <v-row v-if="EditMode === true">
              <v-col>
                <v-text-field
                  v-if="EditMode === true"
                  v-model="profileFileName"
                  label="Current File Name"
                  readonly
                />
              </v-col>
              <v-col>
                <v-file-input
                  label="Data File"
                  v-model="fileData"
                  :rules="EditMode !== true ? inputRules : []"
                  @change="onFileChange(fileData, 'fileData')"
                >
                  >
                </v-file-input>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="profileYear"
                  label="Year"
                />
              </v-col>
            </v-row>
            <v-row>
             <v-col>
            <v-file-input
              v-if="EditMode === false"
              label="Data File"
              v-model="fileData"
              :rules="inputRules"
              @change="onFileChange(fileData, 'fileData')"
            >
              >
            </v-file-input>
             </v-col>
              <v-col>
                  <v-text-field 
                  v-if="EditMode === false"
                    v-model="profileYear"
                    label="Year"
                  />
              </v-col>
            </v-row>
          </div>

          <div v-if="selected == 'state_level'">
            <v-row v-if="EditMode === true">
              <v-col>
                <v-text-field
                  v-if="EditMode === true"
                  v-model="profileFileName"
                  label="Current File Name"
                  readonly
                />
              </v-col>
              <v-col>
                <v-file-input
                  label="Data File"
                  v-model="fileData"
                  :rules="EditMode !== true ? inputRules : []"
                  @change="onFileChange(fileData, 'fileData')"
                >
                  >
                </v-file-input>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="profileYear"
                  label="Year"
                />
              </v-col>
            </v-row>
            <v-row>
             <v-col>
            <v-file-input
              v-if="EditMode === false"
              label="Data File"
              v-model="fileData"
              :rules="inputRules"
              @change="onFileChange(fileData, 'fileData')"
            >
              >
            </v-file-input>
             </v-col>
              <v-col>
                  <v-text-field 
                  v-if="EditMode === false"
                    v-model="profileYear"
                    label="Year"
                  />
              </v-col>
            </v-row>
          </div>

          <div v-if="selected == 'feeder'">
            <v-text-field
              v-model="feederVoltageKV"
              :rules="numberRules"
              type="number"
              label="Feeder Voltage (KV)"
            >
            </v-text-field>

            <v-text-field
              v-model="feederLengthKm"
              :rules="numberRules"
              type="number"
              label="Feeder Length (Km)"
            >
            </v-text-field>

            <!-- <v-text-field
              v-model="sanctionedLoadMW"
              :rules="numberRules"
              type="number"
              label="Sanctioned Load (MW)"
            > 
            </v-text-field>-->
            <v-row v-if="EditMode === true">
              <v-col>
                <v-text-field
                  v-if="EditMode === true"
                  v-model="profileFileName"
                  label="Current File Name"
                  readonly
                />
              </v-col>
              <v-col>
                <v-file-input
                  label="Data File"
                  v-model="fileData"
                  :rules="EditMode !== true ? inputRules : []"
                  @change="onFileChange(fileData, 'fileData')"
                >
                  >
                </v-file-input>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="profileYear"
                  label="Year"
                />
              </v-col>
            </v-row>
            <v-row>
             <v-col>
            <v-file-input
              v-if="EditMode === false"
              label="Data File"
              v-model="fileData"
              :rules="inputRules"
              @change="onFileChange(fileData, 'fileData')"
            >
              >
            </v-file-input>
             </v-col>
              <v-col>
                  <v-text-field 
                  v-if="EditMode === false"
                    v-model="profileYear"
                    label="Year"
                  />
              </v-col>
            </v-row>
          </div>

          <v-checkbox
            v-model="isPublished"
            color="primary"
            v-bind:false-value="false"
            hide-details
          >
            <template v-slot:label> Published </template>
          </v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click.stop="show = false"
            >Close</v-btn
          >
          <v-btn outlined color="primary" @click="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
      <MessageBox
      confirmationTitle="Error in input file"
      :bodyText="errorDescription"
      :visible="isSowfinalMessage"
      @closeBox="closeBox(erroFileInput)"
    />
    </v-form>
 
  </v-dialog>

</template>
<script>
import MessageBox from "@/components/messageBox.vue";
import FeederProfileStore from "@/services/adminfeederstore.js";
import { bus } from "../main";
import loadProfileService from "@/libs/loadProfileService";
import PincodeService from "@/services/pincodeservice.js";
import Selectcustom from "@/components/dropdownlist_custom_item.vue";
import csvFile from "@/services/csvFile";
export default {
  name: "newEditSubstationProfile",
  props: ["visible", "substationProfileData", "EditMode", "profileTypeProp"],
  components: {
    Selectcustom,MessageBox
  },
  data() {
    return {
      errorDescription: "",
      isSowfinalMessage: false,
      profileFileName: "",
      WindowLable: "Load Profile",
      substationName: "",
      feederName: "",
      dtName: "",
      pincodeToolTips: "",
      pincode: "",
      stateName: "",
      color: "green",
      feederVoltageKV: "",
      feederLengthKm: "",
      sanctionedLoadMW: "",
      dtCapacityKVA: "",
      dtTapping: "",
      primaryVoltage: "",
      secondaryVoltage: "",
      totalCapacityMVA: "",
      feederCount: "",
      incomingFeederVoltageKV: "",
      outgoingFeederVoltageKV: "",
      powerFactor: "",
      fileData: [],
      profileYear:"",
      feederProfilefile: null,
      dialog: false,
      id: null,
      title: "",
      voltage: null,
      feederType: "",
      isPublished: false,
      Notification: false,
      errorMsg: null,
      response: [],
      timeout: 5000,
      successMsg: "Record saved successfully",
      inputRules: [(v) => !!v || "This field is required"],
      pincodeRules: [
        (v) => !!v || "Required",
        (v) => v >= 400001 || "Invalide pincode",
      ],
      numberRules: [
        (v) => !!v || "Required",
        (v) => v >= 0 || "Negative value not allowed",
        (v) => v <= 1000 || "Max should not be 1000 ",
      ],
      selected: null,
      profileTypeData: [
        {
          profileTypeId: 4,
          requiredFields: [
            {
              id: 1,
              field: "feederType",
              lable: "Feeder Type",
              validationRouls: "",
              type: "dropdown",
              value: "",
            },
          ],
        },
        {
          profileTypeId: 3,
          requiredFields: [
            {
              id: 1,
              field: "totalCapacityMVA",
              lable: "Total Capacity (MVA)",
              validationRouls: this.numberRules,
              type: "textField",
              value: "",
            },
            {
              id: 2,
              field: "incomingFeederVoltageKV",
              lable: "Incoming Feeder Voltage (KV)",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 3,
              field: "outgoingFeederVoltageKV",
              lable: "Outgoing Feeder Voltage (KV)",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 4,
              field: "feederType",
              lable: "Feeder Type",
              validationRouls: "",
              type: "dropdown",
              value: "",
            },
            {
              id: 5,
              field: "powerFactor",
              lable: "Power Factor",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 6,
              field: "feederLengthKm",
              lable: "Feeder Length (Km)",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 7,
              field: "fileData",
              lable: "Data File",
              validationRouls: "",
              type: "fileInput",
              value: "",
            },
            {
              id: 8,
              field: "profileYear",
              lable: "Year",
              validationRouls: "",
              type: "textField",
              value: "",
            },
          ],
        },
        {
          profileTypeId: 1,
          requiredFields: [
            {
              id: 1,
              field: "dtCapacityKVA",
              lable: "Capacity (KVA)",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 2,
              field: "powerFactor",
              lable: "Power Factor",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 3,
              field: "feederLengthKm",
              lable: "Feeder Length (Km)",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 4,
              field: "dtTapping",
              lable: "Tapping",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 5,
              field: "feederType",
              lable: "Feeder Type",
              validationRouls: "",
              type: "dropdown",
              value: "",
            },
            {
              id: 6,
              field: "primaryVoltage",
              lable: "Primary Voltage",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 7,
              field: "secondaryVoltage",
              lable: "Secondary Voltage",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 8,
              field: "fileData",
              lable: "Data File",
              validationRouls: "",
              type: "fileInput",
              value: "",
            },
            {
              id: 9,
              field: "profileYear",
              lable: "Year",
              validationRouls: "",
              type: "textField",
              value: "",
            },
          ],
        },
        {
          profileTypeId: 2,
          requiredFields: [
            {
              id: 1,
              field: "feederVoltageKV",
              lable: "Feeder Voltage (KV)",
              validationRouls: "",
              type: "textField",
              value: "100",
            },
            {
              id: 2,
              field: "feederLengthKm",
              lable: "Feeder Length (Km)",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 3,
              field: "feederType",
              lable: "Feeder Type",
              validationRouls: "",
              type: "dropdown",
              value: "",
            },
            {
              id: 4,
              field: "sanctionedLoadMW",
              lable: "Sanctioned Load (MW)",
              validationRouls: "",
              type: "textField",
              value: "",
            },
            {
              id: 5,
              field: "fileData",
              lable: "Data File",
              validationRouls: "",
              type: "fileInput",
              value: "",
            },
            {
              id: 6,
              field: "profileYear",
              lable: "Year",
              validationRouls: "",
              type: "textField",
              value: "",
            },
          ],
        },
      ],
      profileType: [
        { id: 1, title: "DT", value: "dt" },
        { id: 2, title: "Feeder", value: "feeder" },
        { id: 3, title: "Substation", value: "substation" },
        { id: 4, title: "State Level", value: "state_level" },
      ],
    };
  },
  computed: {
    show: {
      get() {
        if (this.EditMode) {
          this.FillData();
        }

        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.response);
        }
      },
    },
    filteredProfile() {
      return this.profileTypeData.filter((profile) => {
        if (profile.profileTypeId === this.selected) return profile;
      });
    },
  },
  methods: {
    closeBox(ctrl) {
      this.isSowfinalMessage = false;
    },
    showMessage(ctrl) {
      this.erroFileInput = ctrl;
      this.isSowfinalMessage = true;
    },
    initFormControls() {
      this.selected = this.profileTypeProp;
      this.feederType = "";
      this.id = "";
      this.title = "";
      this.pincode = "";
      this.stateName = "";
      this.feederVoltageKV = "";
      this.feederLengthKm = "";
      this.sanctionedLoadMW = "";
      this.totalCapacityMVA = "";
      (this.feederCount = ""), (this.incomingFeederVoltageKV = "");
      this.outgoingFeederVoltageKV = "";
      this.powerFactor = "";
      this.dtCapacityKVA = "";
      this.dtTapping = "";
      this.primaryVoltage = "";
      this.secondaryVoltage = "";
      this.fileData = "";
      this.profileYear = "",
      this.isPublished = false;
    },
    async saveAction(payload, _status, statusMessage) {
      bus.$emit("SaveNotification", _status, statusMessage);
      if (_status === "OK") {
        bus.$emit(
          "justAddedProfileRecord",
          await this.getLatestRecord(payload._id)
        );
        this.$refs.form.reset();
        this.initFormControls();
        this.$emit("close");
      }
    },
    async upodateAction(payload, _status, statusMessage) {
      bus.$emit("updateNotification", _status, statusMessage);
      if (_status === "OK") {
        bus.$emit(
          "justEditedProfileRecord",
          await this.getLatestRecord(payload._id)
        );
        this.initFormControls();
        this.$emit("close");
      }
    },
    async getLatestRecord(id) {
      const res = await loadProfileService.getLoadProfile(id);
      return res.data;
    },

    onFileChange(file, ctrl) {
      console.log("file", file);
      if (file) {
        const isV_ModelTrigger =
          file.name.split("_").pop() === "finalFile" ? true : false;
        if (!isV_ModelTrigger) {
          this.validateCsv(file, ctrl);
        }
      }
    },
    validateCsv(file, ctrl) {
      let isGreaterValueValidattion = false;

      return csvFile.isValideCSV(file, isGreaterValueValidattion).then((a) => {
        if (a && a.status === false) {
          this.erroFileInput = ctrl;
          this.errorDescription = a.message;
          this.showMessage(ctrl);
          return false;
        } else if (a && a.data && a.status === true) {
          this.setCSVDataToVModel(a.data[0], ctrl);
          return true;
        }
      });
    },

    setCSVDataToVModel(csvdata, ctrl) {
      this.fileData = csvdata;
    },

    onPincodeChange() {
      if (this.pincode && this.pincode.length >= 6) {
        this.getStateName();
      } else {
        this.stateName = "";
      }
    },
    async getStateName() {
      this.stateName = PincodeService.methods.getStateName(this.pincode);
    },
    FillData() {
      if (this.profileTypeProp) {
        this.selected = this.profileTypeProp;
        this.feederType = this.substationProfileData.feederType;
        this.id = this.substationProfileData._id;
        this.title = this.substationProfileData.title;
        this.pincode = this.substationProfileData.pincode;
        this.stateName = this.substationProfileData.stateName;
        this.isPublished = this.substationProfileData.isPublished;
        this.profileFileName = this.substationProfileData.csvFile.name;
        this.profileYear = this.substationProfileData.profileYear;
        this.sanctionedLoadMW = this.substationProfileData.sanctionedLoadMW;
        this.powerFactor = this.substationProfileData.powerFactor;

        if (this.profileTypeProp === "feeder") {
          this.WindowLable = "Edit Feeder Profile";
          this.feederVoltageKV = this.substationProfileData.feederVoltageKV;
          this.feederLengthKm = this.substationProfileData.feederLengthKm;
          this.substationName = this.substationProfileData.substationName;
          this.feederName = this.substationProfileData.feederName;
        }
        if (this.profileTypeProp === "substation") {
          this.WindowLable = "Edit Substation Profile";
          this.totalCapacityMVA = this.substationProfileData.totalCapacityMVA;
          this.feederCount = this.substationProfileData.feederCount;
          this.incomingFeederVoltageKV =
            this.substationProfileData.incomingFeederVoltageKV;
          this.outgoingFeederVoltageKV =
            this.substationProfileData.outgoingFeederVoltageKV;
          this.feederLengthKm = this.substationProfileData.feederLengthKm;
          this.substationName = this.substationProfileData.substationName;
          this.feederName = this.substationProfileData.feederName;
        }
        if (this.profileTypeProp === "dt") {
          this.WindowLable = "Edit DT Profile";
          this.dtCapacityKVA = this.substationProfileData.dtCapacityKVA;
          this.feederLengthKm = this.substationProfileData.feederLengthKm;
          this.dtTapping = this.substationProfileData.dtTapping;
          this.primaryVoltage = this.substationProfileData.primaryVoltage;
          this.secondaryVoltage = this.substationProfileData.secondaryVoltage;
          // this.powerFactor = this.substationProfileData.powerFactor;
          this.substationName = this.substationProfileData.substationName;
          this.dtName = this.substationProfileData.dtName;
        }
        if (this.profileTypeProp === "state_level") {
          this.WindowLable = "Edit State Level Profile";
        }
      }
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.Loading = true;
        if (this.EditMode === false) {
          if (this.selected === "feeder") {
            FeederProfileStore.methods
              .AddFeederProfile(
                this.title,
                this.feederType,
                this.selected,
                this.substationName,
                this.feederName,
                this.feederVoltageKV,
                this.feederLengthKm,
                this.sanctionedLoadMW,
                this.fileData,
                this.profileYear,
                this.pincode,
                this.stateName,
                this.isPublished,
                this.powerFactor
              )
              .then((res) => {
                this.color = "green";
                this.Notification = true;
                this.Loading = false;
                this.errorMsg = this.successMsg;
                const payload = {
                  _id: res.data._id,
                  title: this.title,
                  feederType: this.feederType,
                  profileType: this.selected,
                  substationName: this.substationName,
                  feederName: this.feederName,
                  feederVoltageKV: this.feederVoltageKV,
                  feederLengthKm: this.feederLengthKm,
                  sanctionedLoadMW: this.sanctionedLoadMW,
                  powerFactor: this.powerFactor,
                  pincode: this.pincode,
                  stateName: this.stateName,
                  isPublished: this.isPublished,
                  _updated: res.data._updated,
                  profileYear: this.profileYear
                };
                this.saveAction(payload, res.data._status);
              })
              .catch((error) => {
                this.saveAction(null, 400, error);
              });
          } else if (this.selected === "state_level") {
            FeederProfileStore.methods
              .AddStateLevelProfile(
                this.title,
                this.selected,
                this.fileData,
                this.profileYear,
                // this.pincode,
                // this.stateName,
                this.isPublished
              )
              .then((res) => {
                const payload = {
                  _id: res.data._id,
                  title: this.title,
                  profileType: this.selected,
                  profileYear: this.profileYear,
                  // pincode: this.pincode,
                  // stateName: this.stateName,
                  isPublished: this.isPublished,
                  _updated: res.data._updated,
                };
                this.saveAction(payload, res.data._status);
              })
              .catch((error) => {
                this.saveAction(null, 400, error);
              });
          } else if (this.selected === "dt") {
            FeederProfileStore.methods
              .AddDTProfile(
                this.title,
                this.feederType,
                this.selected,
                this.substationName,
                this.dtName,
                this.feederLengthKm,
                this.powerFactor,
                this.dtCapacityKVA,
                this.dtTapping,
                this.primaryVoltage,
                this.secondaryVoltage,
                this.fileData,
                this.profileYear,
                this.pincode,
                this.stateName,
                this.isPublished,
                this.sanctionedLoadMW
              )
              .then((res) => {
                const payload = {
                  _id: res.data._id,
                  title: this.title,
                  feederType: this.feederType,
                  profileType: this.selected,
                  substationName: this.substationName,
                  dtName: this.dtName,
                  feederLengthKm: this.feederLengthKm,
                  powerFactor: this.powerFactor,
                  sanctionedLoadMW: this.sanctionedLoadMW,
                  dtCapacityKVA: this.dtCapacityKVA,
                  dtTapping: this.dtTapping,
                  primaryVoltage: this.primaryVoltage,
                  secondaryVoltage: this.secondaryVoltage,
                  pincode: this.pincode,
                  stateName: this.stateName,
                  isPublished: this.isPublished,
                  _updated: res.data._updated,
                  profileYear: this.profileYear,
                };
                this.saveAction(payload, res.data._status);
              })
              .catch((error) => {
                this.saveAction(null, 400, error);
              });
          } else if (this.selected === "substation") {
            FeederProfileStore.methods
              .AddSubstationProfile(
                this.title,
                this.feederType,
                this.selected,
                this.substationName,
                this.feederName,
                this.feederLengthKm,
                this.totalCapacityMVA,
                this.feederCount,
                this.incomingFeederVoltageKV,
                this.outgoingFeederVoltageKV,
                this.powerFactor,
                this.fileData,
                this.profileYear,
                this.pincode,
                this.stateName,
                this.isPublished,
                this.sanctionedLoadMW
              )
              .then((res) => {
                res.data;
                const payload = {
                  _id: res.data._id,
                  title: this.title,
                  feederType: this.feederType,
                  profileType: this.selected,
                  substationName: this.substationName,
                  feederName: this.feederName,
                  feederLengthKm: this.feederLengthKm,
                  powerFactor: this.powerFactor,
                  sanctionedLoadMW: this.sanctionedLoadMW,
                  totalCapacityMVA: this.totalCapacityMVA,
                  feederCount: this.feederCount,
                  incomingFeederVoltageKV: this.incomingFeederVoltageKV,
                  outgoingFeederVoltageKV: this.outgoingFeederVoltageKV,
                  pincode: this.pincode,
                  stateName: this.stateName,
                  isPublished: this.isPublished,
                  _updated: res.data._updated,
                  profileYear: this.profileYear,
                };
                this.saveAction(payload, res.data._status);
              })
              .catch((error) => {
                this.saveAction(null, 400, error);
              });
          }
        } else if (this.EditMode === true) {
          if (this.selected === "feeder") {
            const payload = {
              title: this.title,
              feederType: this.feederType,
              profileType: this.selected,
              substationName: this.substationName,
              feederName: this.feederName,
              feederVoltageKV: this.feederVoltageKV,
              feederLengthKm: this.feederLengthKm,
              sanctionedLoadMW: this.sanctionedLoadMW,
              powerFactor: this.powerFactor,
              pincode: this.pincode,
              stateName: this.stateName,
              isPublished: this.isPublished,
              profileYear: this.profileYear,
            };

            if (this.fileData.length !== 0) {
              payload["csvFile"] = this.fileData;
            }
            FeederProfileStore.methods
              .EditProfile(this.id, payload)
              .then((res) => {
                const currenData = {
                  _id: res.data._id,
                  title: this.title,
                  feederType: this.feederType,
                  profileType: this.selected,
                  substationName: this.substationName,
                  feederName: this.feederName,
                  feederVoltageKV: this.feederVoltageKV,
                  feederLengthKm: this.feederLengthKm,
                  powerFactor: this.powerFactor,
                  sanctionedLoadMW: this.sanctionedLoadMW,
                  pincode: this.pincode,
                  stateName: this.stateName,
                  isPublished: this.isPublished,
                  _updated: res.data._updated,
                  profileYear: this.profileYear,
                };
                this.upodateAction(currenData, res.data._status);
              })
              .catch((error) => {
                this.upodateAction(400, error);
              });
          } else if (this.selected === "dt") {
            const payload = {
              title: this.title,
              feederType: this.feederType,
              profileType: this.selected,
              substationName: this.substationName,
              dtName: this.dtName,
              feederLengthKm: this.feederLengthKm,
              powerFactor: this.powerFactor,
              sanctionedLoadMW: this.sanctionedLoadMW,
              dtCapacityKVA: this.dtCapacityKVA,
              dtTapping: this.dtTapping,
              primaryVoltage: this.primaryVoltage,
              secondaryVoltage: this.secondaryVoltage,
              pincode: this.pincode,
              stateName: this.stateName,
              isPublished: this.isPublished,
              // csvFile:this.fileData
              profileYear: this.profileYear
            };
            if (this.fileData.length !== 0) {
              payload["csvFile"] = this.fileData;
            }

            FeederProfileStore.methods
              .EditProfile(this.id, payload)
              .then((res) => {
                const currenData = {
                  _id: res.data._id,
                  title: this.title,
                  feederType: this.feederType,
                  profileType: this.selected,
                  substationName: this.substationName,
                  dtName: this.dtName,
                  feederLengthKm: this.feederLengthKm,
                  powerFactor: this.powerFactor,
                  sanctionedLoadMW: this.sanctionedLoadMW,
                  dtCapacityKVA: this.dtCapacityKVA,
                  dtTapping: this.dtTapping,
                  primaryVoltage: this.primaryVoltage,
                  secondaryVoltage: this.secondaryVoltage,
                  pincode: this.pincode,
                  stateName: this.stateName,
                  isPublished: this.isPublished,
                  _updated: res.data._updated,
                  profileYear: this.profileYear,
                };
                this.upodateAction(currenData, res.data._status);
              })
              .catch((error) => {
                this.upodateAction(400, error);
              });
          } else if (this.selected === "state_level") {
            const payload = {
              title: this.title,
              profileType: this.selected,
              // pincode: this.pincode,
              // stateName: this.stateName,
              isPublished: this.isPublished,
            };
            if (this.fileData.length !== 0) {
              payload["csvFile"] = this.fileData;
            }

            FeederProfileStore.methods
              .EditProfile(this.id, payload)
              .then((res) => {
                const currenData = {
                  _id: res.data._id,
                  title: this.title,
                  profileType: this.selected,
                  // pincode: this.pincode,
                  // stateName: this.stateName,
                  isPublished: this.isPublished,
                  _updated: res.data._updated,
                  profileYear: this.profileYear,
                };
                this.upodateAction(currenData, res.data._status);
              })
              .catch((error) => {
                this.upodateAction(400, error);
              });
          } else if (this.selected === "substation") {
            const payload = {
              title: this.title,
              feederType: this.feederType,
              profileType: this.selected,
              substationName: this.substationName,
              feederName: this.feederName,
              feederLengthKm: this.feederLengthKm,
              totalCapacityMVA: this.totalCapacityMVA,
              feederCount: this.feederCount,
              incomingFeederVoltageKV: this.incomingFeederVoltageKV,
              outgoingFeederVoltageKV: this.outgoingFeederVoltageKV,
              powerFactor: this.powerFactor,
              sanctionedLoadMW: this.sanctionedLoadMW,
              pincode: this.pincode,
              stateName: this.stateName,
              isPublished: this.isPublished,
              profileYear: this.profileYear,
            };
            if (this.fileData.length !== 0) {
              payload["csvFile"] = this.fileData;
            }
            FeederProfileStore.methods
              .EditProfile(this.id, payload)
              .then((res) => {
                const currenData = {
                  _id: res.data._id,
                  title: this.title,
                  feederType: this.feederType,
                  profileType: this.selected,
                  substationName: this.substationName,
                  feederName: this.feederName,
                  feederLengthKm: this.feederLengthKm,
                  totalCapacityMVA: this.totalCapacityMVA,
                  feederCount: this.feederCount,
                  incomingFeederVoltageKV: this.incomingFeederVoltageKV,
                  outgoingFeederVoltageKV: this.outgoingFeederVoltageKV,
                  powerFactor: this.powerFactor,
                  sanctionedLoadMW: this.sanctionedLoadMW,
                  pincode: this.pincode,
                  stateName: this.stateName,
                  isPublished: this.isPublished,
                  _updated: res.data._updated,
                  profileYear: this.profileYear,
                };
                this.upodateAction(currenData, res.data._status);
              })
              .catch((error) => {
                this.upodateAction(400, error);
              });
          }
        }
      }
    },
    setval(e) {
      if (e.datasource === "feederTypes") {
        this.feederType = e.value;
      }
    },
  },
  // watch: {
  //   fileData(newval) {
  //     console.log("filedata", newval);
  //   },
  // },
};
</script>